import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "Do you come to my home?", a: "Yes. We provide fully mobile service at homes, workplaces, apartment parking, and roadside locations throughout our service area." },
  { q: "What areas do you service?", a: "Calgary, Airdrie, Chestermere, Cochrane, Okotoks, Rocky View County and nearby communities. If you're unsure, give us a call." },
  { q: "Do I need to provide tools?", a: "No — we bring our own professional mobile equipment including mounting, balancing and torque tools." },
  { q: "How long does a tire swap take?", a: "Most seasonal changeovers take approximately 30–60 minutes depending on the vehicle and whether tires are already on rims." },
  { q: "Do you balance tires?", a: "Yes. We use a professional wheel balancer on-site for all installs, ensuring a smooth, vibration-free ride." },
  { q: "Can you repair flats?", a: "Absolutely. We handle puncture repair, leak diagnosis, and roadside flat tire replacement." },
  { q: "What payment methods are accepted?", a: "We accept e-transfer, credit and debit cards on-site. Ask about invoicing for fleet accounts." },
  { q: "Do you service fleets?", a: "Yes. We offer dedicated fleet tire services for contractors, delivery companies, and small businesses to minimize downtime." },
];

export const FAQ = () => (
  <section id="faq" className="section-mv bg-white">
    <div className="container-mv max-w-3xl">
      <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">FAQ</div>
      <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-black">
        Questions? <span className="text-brand-red">We've got answers.</span>
      </h2>

      <Accordion type="single" collapsible className="mt-10">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-b border-neutral-200">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display font-semibold text-lg text-brand-black hover:no-underline hover:text-brand-red py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-neutral-600 leading-relaxed text-[15px] pb-5">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
